import { render, staticRenderFns } from "./SectionEducation.vue?vue&type=template&id=39994944&scoped=true&"
import script from "./SectionEducation.vue?vue&type=script&lang=js&"
export * from "./SectionEducation.vue?vue&type=script&lang=js&"
import style0 from "./SectionEducation.vue?vue&type=style&index=0&id=39994944&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39994944",
  null
  
)

export default component.exports